import { IInvoice } from "interfaces/entities/invoice";
import { ActionsUnion } from "store/helper";

import { createEntityActionNames, createEntityActions } from "../actions";

import { IFetchInvoicesCollectionPayload } from "./interfaces";

export const INVOICE = {
  ...createEntityActionNames("INVOICE"),
};

export const InvoiceActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  ...createEntityActions<IInvoice, {}, IFetchInvoicesCollectionPayload>(INVOICE),
};

export type InvoiceAction = ActionsUnion<typeof InvoiceActions>;
